// src/components/profile/ExecutiveOverview/HeroSummary.jsx
import React from 'react';
import { TrendingUp } from 'lucide-react';

export default function HeroSummary({ takeaway, tags = [] }) {
  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-3 mb-2"> {/* Reduced from p-6 mb-6 */}
      <div className="flex items-center gap-2 mb-2"> {/* Reduced from mb-3 */}
        <TrendingUp className="w-4 h-4 text-indigo-600" /> {/* Reduced from w-5 h-5 */}
        <h2 className="text-xs font-semibold uppercase tracking-wider text-indigo-900"> {/* Reduced from text-sm */}
          Impact Summary
        </h2>
      </div>
      
      <div className="border-l-4 border-indigo-500 pl-3"> {/* Reduced from pl-4 */}
        <p className="text-sm text-slate-800 leading-snug font-medium"> {/* Reduced from text-base md:text-lg, changed to leading-snug */}
          {takeaway}
        </p>
        
        {/* Remove tags section since we don't want the badges anymore */}
      </div>
    </div>
  );
}